import { delay, all, call, put, select, takeLatest } from 'redux-saga/effects';

import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { authService, statsService } from 'utils/api';

import { DESTROY_SESSION, SELECT_PROPERTY, SET_PREFERENCES } from './constants';
import { resetApp, updateSelectedPropertyExtraDetails, updateConfig } from './actions';
import { selectUserPreferences, selectUserToken } from './selectors';
import { parseUserProperties } from 'containers/LoginPage/utils';

function* destroySessionSaga() {
    yield put(resetApp());
}

function* setPreferencesSaga() {
    yield delay(1500); // Debounce by 1500ms

    const token = yield select(selectUserToken);
    const userPreferences = yield select(selectUserPreferences);
    yield call(withApiErrorHandling, authService({ token }).setUserPreferences, {
        preferences: userPreferences,
    });
}
function* getPropertyInfo({ propertyId }) {
    const token = yield select(selectUserToken);
    const { response } = yield call(withApiErrorHandling, statsService({ token, propertyId }).getUserPropertyExtraInfo);

    const { response: userConfigResponse } = yield call(
        withApiErrorHandling,
        statsService({ token, propertyId }).getUserPropertyConfig,
    );
    const { response: propertyResponse } = yield call(withApiErrorHandling, authService({ token }).getUserProperties);
    const authorisedProperties = yield call(parseUserProperties, propertyResponse.data);
    const selectedProperty = { ...authorisedProperties[propertyId], ...response.data };

    yield put(updateSelectedPropertyExtraDetails({ ...authorisedProperties, [propertyId]: selectedProperty }));
    yield put(updateConfig(userConfigResponse.data));
}

export default function* sessionSaga() {
    yield all([
        takeLatest(DESTROY_SESSION, destroySessionSaga),
        takeLatest(SET_PREFERENCES, setPreferencesSaga),
        takeLatest(SELECT_PROPERTY, getPropertyInfo),
    ]);
}

export { destroySessionSaga, setPreferencesSaga };
